import * as Sentry from "@sentry/vue";

export default defineNuxtPlugin((nuxtApp) => {
    const router = useRouter();
    const {
        public: { sentry },
    } = useRuntimeConfig();

    if (!sentry.dsn) {
        return;
    }

    const isProd = sentry.environment === "production";

    const tracesSampleRate = isProd ? 0.05 : 0.2; // 5% transactions in prod
    const sampleRate = isProd ? 0.25 : 1.0; // 25% error events in prod
    const replaysSessionSampleRate = isProd ? 0.02 : 1.0; // 2% full session replays in prod
    const replaysOnErrorSampleRate = isProd ? 0.2 : 1.0; // 20% replays on error in prod

    Sentry.init({
        app: nuxtApp.vueApp,
        dsn: sentry.dsn,
        environment: sentry.environment,
        maxBreadcrumbs: 25,
        // v11 collects everything by default; keep v10's restrictive behaviour (no cookies, bodies or auto user info)
        dataCollection: {
            userInfo: false,
            cookies: false,
            httpHeaders: { request: { allow: ["User-Agent", "Referer"] }, response: false },
            httpBodies: [],
        },
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],

        sampleRate: sampleRate,
        tracesSampleRate: tracesSampleRate,

        tracePropagationTargets: [
            "http://api.access.kadewe.localhost:8080",
            "https://api.access.housesofkadewe.com",
            "https://staging.api.access.housesofkadewe.com",
        ],

        replaysSessionSampleRate: replaysSessionSampleRate,
        replaysOnErrorSampleRate: replaysOnErrorSampleRate,
    });
});
